import { render } from "./FullScreenLayout.vue?vue&type=template&id=53d62e3b&scoped=true"
const script = {}

import "./FullScreenLayout.vue?vue&type=style&index=0&id=53d62e3b&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d62e3b"]])

export default __exports__